import type { BlogDetailMeta } from '@/hooks/useBlogDetail';

export default function BlogHero({ meta }: { meta: BlogDetailMeta }) {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center justify-center overflow-hidden pt-20">
      <img
        src={meta.image}
        alt={meta.title}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <p className="text-accent-400 text-sm md:text-base tracking-wide uppercase mb-3">
          {meta.category}
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
          {meta.title}
        </h1>
        {meta.excerpt && (
          <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            {meta.excerpt}
          </p>
        )}
      </div>
    </section>
  );
}